import { Dialog } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import ENV from '../../base/env';
import './RestoreConfirmationPopup.scss';

export interface IRestoreConfirmationPopupProps {
  show: boolean;
  onClose: () => void;
}

export default function RestoreConfirmationPopup({ show, onClose }: Readonly<IRestoreConfirmationPopupProps>) {
  const { t } = useTranslation();
  const title = t('manage:Manage.Restore.ConfirmationTitle');
  return (
    <Dialog
      lazy={true}
      usePortal={true}
      autoFocus={true}
      isOpen={show}
      canOutsideClickClose={true}
      canEscapeKeyClose={true}
      onClose={onClose}
      title={title}
      className="restore-subscription-confirmation"
      bodyClassName="restore-subscription-confirmation-body container">
      <div className="row">
        <div className="col-4 col-m-4 illustration-container">
          <img className="illustration" src={`${ENV.AssetsBaseUrl}/feature/RestoreConfirmation.png`} alt={title} />
        </div>
        <div className="col-8 col-m-4">
          <h3>{title}</h3>
          <p>{t('manage:Manage.Restore.ConfirmationText')}</p>
        </div>
      </div>
    </Dialog>
  );
}
